import React, { lazy, Suspense } from 'react';
import { Router, Switch } from 'react-router-dom';
import Spinner from '../components/Spinner';
import NavbarOnlyRoutes from '../HOCs/NavbarOnlyRoutes';
import history from './history';

const LazyDashboard = lazy(() => import('../views/Home'));
const LazyAbout = lazy(() => import('../components/About/about'));
const LazyContact = lazy(() => import('../components/ContactUs/contact'));
const LazyMyCatalogue = lazy(() => import('../views/MyCatalogue'));
const LazyCart = lazy(() => import('../views/Cart'));
const LazyCatalogueProductDetail = lazy(() =>
  import('../views/CatalogueProductDetail')
);
const LazySlugCatalogueProductDetail = lazy(() =>
  import('../views/SlugCatalogueProductDetails')
);
const LazyNews = lazy(() => import('../views/News'));
const LazyNewsView = lazy(() => import('../views/NewsView'));

const AppRouter = (props) => {
  return (
    <Router history={history} basename={'/'}>
      <Switch>
        <NavbarOnlyRoutes
          path="/about"
          exact
          render={(matchprops) => {
            return (
              <Suspense fallback={<Spinner />}>
                <LazyAbout {...matchprops} />
              </Suspense>
            );
          }}
        />
        <NavbarOnlyRoutes
          path="/contactus"
          exact
          render={(matchprops) => {
            return (
              <Suspense fallback={<Spinner />}>
                <LazyContact {...matchprops} />
              </Suspense>
            );
          }}
        />
        <NavbarOnlyRoutes
          path="/cart"
          exact
          render={(matchprops) => {
            return (
              <Suspense fallback={<Spinner />}>
                <LazyCart {...matchprops} />
              </Suspense>
            );
          }}
        />
        <NavbarOnlyRoutes
          path="/news"
          exact
          render={(matchprops) => {
            return (
              <Suspense fallback={<Spinner />}>
                <LazyNews {...matchprops} />
              </Suspense>
            );
          }}
        />
        <NavbarOnlyRoutes
          path="/news/view"
          exact
          render={(matchprops) => {
            return (
              <Suspense fallback={<Spinner />}>
                <LazyNewsView {...matchprops} />
              </Suspense>
            );
          }}
        />

        <NavbarOnlyRoutes
          path="/my-catalogue/:slug"
          exact
          render={(matchprops) => {
            console.log(matchprops, 'matchprops');
            return (
              <Suspense fallback={<Spinner />}>
                <LazyMyCatalogue
                  {...matchprops}
                  isAuthenticated={props.isAuthenticated}
                  user={props.loginDetails}
                />
              </Suspense>
            );
          }}
        />

        <NavbarOnlyRoutes
          path="/view"
          exact
          render={(matchprops) => {
            console.log(matchprops);
            return (
              <Suspense fallback={<Spinner />}>
                <LazyCatalogueProductDetail {...matchprops} />
              </Suspense>
            );
          }}
        />

        <NavbarOnlyRoutes
          path="/:slug"
          exact
          render={(matchprops) => {
            console.log(matchprops);
            return (
              <Suspense fallback={<Spinner />}>
                <LazySlugCatalogueProductDetail {...matchprops} />
              </Suspense>
            );
          }}
        />
        <NavbarOnlyRoutes
          path="/"
          exact
          render={(matchprops) => {
            // console.log(matchprops);
            return (
              <Suspense fallback={<Spinner />}>
                <LazyDashboard {...matchprops} />
              </Suspense>
            );
          }}
        />
        <NavbarOnlyRoutes
          path="*"
          exact
          render={(matchprops) => {
            // console.log(matchprops);
            return history.push('/');
          }}
        />
      </Switch>
    </Router>
  );
};

export default AppRouter;
